'use strict';

module.exports = require('./ReactRevealText')["default"];